import { Component, input } from '@angular/core';

@Component({
  selector: 'rid-klank-card',
  imports: [],
  templateUrl: './rid-klank-card.html',
})
export class RidKlankCard {
  klank = input.required<string>();
  disabled = input<boolean>();
}
